export { RevealOnScroll } from './RevealOnScroll';
export type { RevealOnScrollProps, RevealOnScrollTag } from './types';
